module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/brand-profile/brand-profile.component.scss
// module id = ./src/app/brand-profile/brand-profile.component.scss
// module chunks = main